window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import lazySizes from 'lazysizes'
lazySizes.cfg.init = false; // Init false
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Alpine - https://alpinejs.dev/essentials/installation
// import Alpine from 'alpinejs'
// window.Alpine = Alpine

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fCarousels = require('./components/carousels')
const fGSAPController = require('./components/gsap-controller')
const fAccordion = require('./components/accordion')
const fMenuCollapse = require('./components/menu-collapse')
const fMenuOnScroll = require('./components/menu-onscroll-mobile')
const fMenuUnderlineSections = require('./components/menu-underline-sections')

import SlideUpDown from 'vue3-slide-up-down'

import './utils/jquery.session';
import './utils/jquery.nice-select.min';
 
// Vue Support Function
import {
    createApp,
    defineAsyncComponent
} from 'vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'

const InitVueComponents = () => {
    // Async components
    // const SimpleComponent = defineAsyncComponent(() => import("./vue/simple-component"));
    // Static Components
    const GoogleMapComponent = require('./vue/google-map').default;
    const RelatedPosts = require('./vue/posts-related').default;
    const BlogPosts = require('./vue/blog-posts').default;
    const AnimatedMap = require('./vue/animated-map').default;
    const AnimatedMapPoint = require('./vue/animated-map-point').default;
    // Init Vue Instance
    const $VueApp = createApp({});

    // component() can be chained :)
    $VueApp.use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyABHeCCIFfmqZai6YEMV9QR2VtDPCdZySQ',
            // language: 'de',
        },
        autobindAllEvents: true,
    });
    $VueApp
        .component('slide-up-down', SlideUpDown)
        .component('blog-posts', BlogPosts)
        .component("gmap", GoogleMapComponent)
        .component("posts-related", RelatedPosts)
        .component("animated-map", AnimatedMap)
        .component("animated-map-point", AnimatedMapPoint);
    $VueApp.mount('#vue-space');
}

/**
 * Before refresh go to top page
 */
// window.onbeforeunload = function () {
//     window.scrollTo(0, 0);
// }

// Fade in website
if ( jQuery.session.get('animation') === 'showed' && document.querySelector('.home-hero') ) {
    document.querySelector('body').classList.remove('overflow-hidden', 'bg-gradient-to-r');
    document.querySelector('.home-hero').style.display = 'none';
    document.querySelector('.home-hero__wrapper').classList.remove('beforeAnimation');
    document.querySelector('.home-hero__wrapper').classList.add('afterAnimation');
    document.querySelector('#vue-space').style.opacity = 1;
}

// Initialise our components on jQuery.ready…
jQuery(function ($) {

    // Static Functions
    InitVueComponents()
    fAccordion()
    fMenuCollapse()
    fMenuOnScroll()
    // plugins
    // Alpine.start()

    // Async Functions
    fGSAPController.init()
    fCarousels.init()
    fSmoothScroll()
    fMenuUnderlineSections()

    lazySizes.init();

    /**
     * Contact form 7
     */
    $('.wpcf7 select').niceSelect();

    document.addEventListener( 'wpcf7mailsent', function( event ) {
        $('.form-message-sent').show();
        setTimeout(() => {
            $('.form-message-sent').fadeOut();
        }, 2500);
    }, false);
    if (window.location.href.indexOf('/leasing') >= 0) {
        jQuery.session.set('animation', 'showed');
    }
    
})